import SelectorVM from './selector-vm';
import Vue from 'vue';
import 'libs/vue-extensions';
export default {
  init : function(element) {
    let vm = new Vue(SelectorVM);
    vm.$mount(element);
  }
};
